<div class="tasks-page" [hidden]="!!customerId">
  <mat-tab-group
    [(selectedIndex)]="matTabIndex"
    class="tasks-page__tabs"
    (selectedIndexChange)="updateUrl($event)"
    animationDuration="0ms"
    disableRipple
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tasks-page__tab-label">
          <span>{{ "CRM.saleTasks.myTasks" | translate }}</span>
        </div>
      </ng-template>

      <div class="tasks-page__section">
        <div class="tasks-page__toolbar">
          <button
            mat-button
            class="tasks-page__filter-toggle"
            (click)="toggleFilters()"
          >
            <span class="tasks-page__filter-toggle-icon">
              @if (!filterExpanded) {
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10l5 5 5-5H7z"/>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 14l5-5 5 5H7z"/>
                </svg>
              }
            </span>
            <span>{{ 'CRM.customersAndLead.filter' | translate }}</span>
          </button>
        </div>

        <div class="tasks-page__filter-shell" [@slideToggle]="filterExpanded ? 'visible' : 'hidden'">
          <form class="tasks-filter-card" [formGroup]="searchForm">
            <div class="tasks-filter-card__header">
              <div class="tasks-filter-card__title-block">
                <span class="tasks-filter-card__eyebrow font-walter">
                  {{ 'crm.pages.tasks.tasks.filtri' | translate }}
                </span>
                <h3 class="tasks-filter-card__title">
                  {{ 'crm.pages.tasks.tasks.leMieAttivita' | translate }}
                </h3>
              </div>
            </div>

            <div class="tasks-filter-card__content">
              <div class="tasks-filter-card__group">
                <label class="tasks-filter-card__group-label">
                  {{ 'generics.cols.expiration' | translate }}
                </label>

                <div class="tasks-filter-card__grid tasks-filter-card__grid--dates" formGroupName="expirationDate">
                  <app-input
                    formControlName="from"
                    [placeholder]="'generics.cols.from' | translate"
                    type="date"
                  ></app-input>

                  <app-input
                    formControlName="to"
                    [placeholder]="'generics.cols.to' | translate"
                    type="date"
                  ></app-input>
                </div>
              </div>

              <div class="tasks-filter-card__grid tasks-filter-card__grid--filters">
                <app-input
                  [label]="'generics.cols.type' | translate"
                  formControlName="type"
                  type="selection"
                  [selectionOptions]="selectionTasks"
                ></app-input>

                <app-input
                  [label]="'generics.cols.customer' | translate"
                  formControlName="customer"
                  type="text"
                ></app-input>

                <app-input
                  [label]="'generics.cols.summary' | translate"
                  formControlName="summary"
                  type="text"
                ></app-input>
              </div>
            </div>

            <div class="tasks-filter-card__footer">
              <button
                type="button"
                class="tasks-filter-card__btn tasks-filter-card__btn--primary force-text-white"
                (click)="doSearch()"
              >

                <span>{{ 'generics.cols.search' | translate }}</span>
              </button>

              <button
                type="button"
                class="tasks-filter-card__btn tasks-filter-card__btn--secondary"
                (click)="clearFilter()"
              >
                <i class="icon-ipe-clear" aria-hidden="true"></i>
                <span>{{ 'generics.cols.clean' | translate }}</span>
              </button>
            </div>
          </form>
        </div>

        @if (matTabIndex === 0) {
          <div class="tasks-page__table-shell">
            <app-tree
              [dataSource]="tasks"
              [columns]="['daysLeft', 'type', 'customer', 'summary', 'expirationDate', 'expirationState']"
              [actions]="actions.tasks"
              (clickRow)="openRowDetail($event)"
              [widgetOptions]="widgetOptions"
            ></app-tree>
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tasks-page__tab-label">
          <span>{{ "CRM.saleTasks.assigned" | translate }}</span>
        </div>
      </ng-template>

      <div class="tasks-page__section">
        <div class="tasks-page__toolbar">
          <button
            mat-button
            class="tasks-page__filter-toggle"
            (click)="toggleFilters()"
          >
            <span class="tasks-page__filter-toggle-icon">
              @if (!filterExpanded) {
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10l5 5 5-5H7z"/>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 14l5-5 5 5H7z"/>
                </svg>
              }
            </span>
            <span>{{ 'CRM.customersAndLead.filter' | translate }}</span>
          </button>
        </div>

        <div class="tasks-page__filter-shell" [@slideToggle]="filterExpanded ? 'visible' : 'hidden'">
          <form class="tasks-filter-card" [formGroup]="searchForm">
            <div class="tasks-filter-card__header">
              <div class="tasks-filter-card__title-block">
                <span class="tasks-filter-card__eyebrow font-walter">
                  {{ 'crm.pages.tasks.tasks.filtri' | translate }}
                </span>
                <h3 class="tasks-filter-card__title">
                  {{ 'crm.pages.tasks.tasks.attivitaAssegnate' | translate }}
                </h3>
              </div>
            </div>

            <div class="tasks-filter-card__content">
              <div class="tasks-filter-card__group">
                <label class="tasks-filter-card__group-label">
                  {{ 'generics.cols.expiration' | translate }}
                </label>

                <div class="tasks-filter-card__grid tasks-filter-card__grid--dates" formGroupName="expirationDate">
                  <app-input
                    formControlName="from"
                    [placeholder]="'generics.cols.from' | translate"
                    type="date"
                  ></app-input>

                  <app-input
                    formControlName="to"
                    [placeholder]="'generics.cols.to' | translate"
                    type="date"
                  ></app-input>
                </div>
              </div>

              <div class="tasks-filter-card__grid tasks-filter-card__grid--filters">
                <app-input
                  [label]="'generics.cols.type' | translate"
                  formControlName="type"
                  type="selection"
                  [selectionOptions]="selectionTasks"
                ></app-input>

                <app-input
                  [label]="'generics.cols.seller' | translate"
                  formControlName="seller"
                  type="text"
                ></app-input>

                <app-input
                  [label]="'generics.cols.customer' | translate"
                  formControlName="customer"
                  type="text"
                ></app-input>

                <app-input
                  [label]="'generics.cols.summary' | translate"
                  formControlName="summary"
                  type="text"
                ></app-input>
              </div>
            </div>

            <div class="tasks-filter-card__footer">
              <button
                type="button"
                class="tasks-filter-card__btn tasks-filter-card__btn--primary force-text-white"
                (click)="doSearch()"
              >

                <span>{{ 'generics.cols.search' | translate }}</span>
              </button>

              <button
                type="button"
                class="tasks-filter-card__btn tasks-filter-card__btn--secondary"
                (click)="clearFilter()"
              >
                <i class="icon-ipe-clear" aria-hidden="true"></i>
                <span>{{ 'generics.cols.clean' | translate }}</span>
              </button>
            </div>
          </form>
        </div>

        @if (matTabIndex === 1) {
          <div class="tasks-page__table-shell">
            <app-tree
              [dataSource]="tasks"
              [columns]="['daysLeft', 'type', 'seller', 'customer', 'summary', 'expirationDate', 'expirationState']"
              [actions]="actions.tasks"
              (clickRow)="openRowDetail($event)"
              [widgetOptions]="widgetOptions"
            ></app-tree>
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tasks-page__tab-label">
          <span>{{ "CRM.saleTasks.completed" | translate }}</span>
        </div>
      </ng-template>

      <div class="tasks-page__section">
        <div class="tasks-page__toolbar">
          <button
            mat-button
            class="tasks-page__filter-toggle"
            (click)="toggleFilters()"
          >
            <span class="tasks-page__filter-toggle-icon">
              @if (!filterExpanded) {
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10l5 5 5-5H7z"/>
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 14l5-5 5 5H7z"/>
                </svg>
              }
            </span>
            <span>{{ 'CRM.customersAndLead.filter' | translate }}</span>
          </button>
        </div>

        <div class="tasks-page__filter-shell" [@slideToggle]="filterExpanded ? 'visible' : 'hidden'">
          <form class="tasks-filter-card" [formGroup]="searchForm">
            <div class="tasks-filter-card__header">
              <div class="tasks-filter-card__title-block">
                <span class="tasks-filter-card__eyebrow font-walter">
                  {{ 'crm.pages.tasks.tasks.filtri' | translate }}
                </span>
                <h3 class="tasks-filter-card__title">
                  {{ 'crm.pages.tasks.tasks.attivitaCompletate' | translate }}
                </h3>
              </div>
            </div>

            <div class="tasks-filter-card__content">
              <div class="tasks-filter-card__group">
                <label class="tasks-filter-card__group-label">
                  {{ 'generics.cols.expiration' | translate }}
                </label>

                <div class="tasks-filter-card__grid tasks-filter-card__grid--dates" formGroupName="expirationDate">
                  <app-input
                    formControlName="from"
                    [placeholder]="'generics.cols.from' | translate"
                    type="date"
                  ></app-input>

                  <app-input
                    formControlName="to"
                    [placeholder]="'generics.cols.to' | translate"
                    type="date"
                  ></app-input>
                </div>
              </div>

              <div class="tasks-filter-card__group">
                <label class="tasks-filter-card__group-label">
                  {{ 'generics.cols.completion' | translate }}
                </label>

                <div class="tasks-filter-card__grid tasks-filter-card__grid--dates" formGroupName="completionDate">
                  <app-input
                    formControlName="from"
                    [placeholder]="'generics.cols.from' | translate"
                    type="date"
                  ></app-input>

                  <app-input
                    formControlName="to"
                    [placeholder]="'generics.cols.to' | translate"
                    type="date"
                  ></app-input>
                </div>
              </div>

              <div class="tasks-filter-card__grid tasks-filter-card__grid--filters">
                <app-input
                  [label]="'generics.cols.type' | translate"
                  formControlName="type"
                  type="selection"
                  [selectionOptions]="selectionTasks"
                ></app-input>

                <app-input
                  [label]="'generics.cols.seller' | translate"
                  formControlName="seller"
                  type="text"
                ></app-input>

                <app-input
                  [label]="'generics.cols.customer' | translate"
                  formControlName="customer"
                  type="text"
                ></app-input>

                <app-input
                  [label]="'generics.cols.summary' | translate"
                  formControlName="summary"
                  type="text"
                ></app-input>
              </div>
            </div>

            <div class="tasks-filter-card__footer">
              <button
                type="button"
                class="tasks-filter-card__btn tasks-filter-card__btn--primary force-text-white"
                (click)="doSearch()"
              >

                <span>{{ 'generics.cols.search' | translate }}</span>
              </button>

              <button
                type="button"
                class="tasks-filter-card__btn tasks-filter-card__btn--secondary"
                (click)="clearFilter()"
              >
                <i class="icon-ipe-clear" aria-hidden="true"></i>
                <span>{{ 'generics.cols.clean' | translate }}</span>
              </button>
            </div>
          </form>
        </div>

        @if (matTabIndex === 2) {
          <div class="tasks-page__table-shell">
            <app-tree
              [dataSource]="tasks"
              [columns]="['efficiency', 'type', 'seller', 'customer', 'summary', 'expirationDate', 'completionDate']"
              [actions]="actions.tasks"
              (clickRow)="openRowDetail($event)"
              [widgetOptions]="widgetOptions"
            ></app-tree>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

@if (matTabIndex === 10 && !!customerId) {
  <div class="tasks-page__customer-shell">
    <div class="tasks-page__table-shell">
      <app-tree
        [dataSource]="tasks"
        [columns]="['efficiency', 'type', 'seller', 'customer', 'summary', 'expirationDate', 'completionDate']"
        [actions]="actions.tasks"
        (clickRow)="openRowDetail($event, customerRedirect)"
        [widgetOptions]="widgetOptions"
      ></app-tree>
    </div>
  </div>
}
